import{withBaseSelectListBoxStyle as t}from"./BaseSelect.js";import e from"@mui/joy/AutocompleteListbox";var o=t(e);export{o as BaseAutocompleteListbox};
//# sourceMappingURL=BaseAutocompleteListbox.js.map